import { flex, gap, screen, spacing } from '@ebh/capsule/theme';
import { css } from '@emotion/react';
import { THEME_COLORS } from '../../utils/theme/colors';

export default {
  container: [flex('column'), gap(2), { width: '100%' }],
  input: [
    css`
      input {
        font-size: 16px;
        ${screen('md', { fontSize: spacing(4) })}
      }
      input:disabled {
        background-color: ${THEME_COLORS['gray-100']};
      }
      p {
        color: ${THEME_COLORS['gray-600']};
      }
      input:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px white inset !important;
      }
    `,
  ],
  error: [flex('row', 'items-center')],
};
